import { get } from 'lodash';

import { INITIAL_MATCHES_STATUS_COMPLETED } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const getMatchesInitializeStatus = (state) => {
  const initialMatchStatus = get(state, 'shopify.shopifySettings.settings.initialMatchStatus', '');

  return initialMatchStatus === INITIAL_MATCHES_STATUS_COMPLETED;
};
